import { render, staticRenderFns } from "./InputAulaTeorica.vue?vue&type=template&id=f2cafc98&scoped=true"
import script from "./InputAulaTeorica.vue?vue&type=script&lang=js"
export * from "./InputAulaTeorica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cafc98",
  null
  
)

export default component.exports